export default __webpack_public_path__ + "static/media/Angular.149f3977.png";